import { useState } from 'react';
import UpgradeModal from './UpgradeModal';

/**
 * Shown when the user has exhausted their daily quota for a rate-limited
 * feature.  Replaces the input area with a blocking message and upgrade
 * CTAs.
 *
 * Reset time is static text per spec — no live countdown.
 *
 * @param {Object} props
 * @param {string} props.featureLabel - e.g. "Game Chat"
 * @param {number} props.total - daily limit for display
 * @param {"game_chat"|"education_qa"} props.featureKey - for upgrade modal triggerFeature
 */
export default function AtLimitMessage({ featureLabel, total, featureKey }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [suggestedTier, setSuggestedTier] = useState('pro');

  function openModal(tier) {
    setSuggestedTier(tier);
    setModalOpen(true);
  }

  const isGameChat = featureKey === 'game_chat';

  return (
    <>
      <div className="rounded-lg border border-[#e2e8f0] dark:border-[#1e2536] bg-[rgba(107,114,128,0.04)] dark:bg-[rgba(107,114,128,0.06)] px-4 py-4 text-center">
        <p className="text-[14px] font-medium text-[#111827] dark:text-[#e2e8f0] mb-1">
          You've used today's {featureLabel} questions
        </p>
        <p className="text-[13px] text-[#6b7280] dark:text-[#8892a8] mb-4">
          Your {total} daily question{total !== 1 ? 's' : ''} will reset at 8 PM ET
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
          <button
            onClick={() => openModal('pro')}
            className="w-full sm:w-auto px-4 py-2 rounded-md bg-[#005BB3] hover:bg-[#004a93] text-white text-[13px] font-medium transition-colors"
          >
            Upgrade to Pro — {isGameChat ? '10 questions/day' : 'Unlimited'}
          </button>
          {isGameChat && (
            <button
              onClick={() => openModal('premium')}
              className="w-full sm:w-auto px-4 py-2 rounded-md border border-[#e2e8f0] dark:border-[#2d3748] text-[#111827] dark:text-[#e2e8f0] hover:bg-[rgba(0,0,0,0.03)] dark:hover:bg-[rgba(255,255,255,0.03)] text-[13px] font-medium transition-colors"
            >
              Upgrade to Premium — Unlimited
            </button>
          )}
        </div>
      </div>

      <UpgradeModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        suggestedTier={suggestedTier}
        triggerFeature={featureKey}
      />
    </>
  );
}
